import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import * as _ from 'lodash';
import { NbDialogService } from '@nebular/theme';
import { DialogOKComponent } from '../../modals/dialog-ok.component';
import { FileUploadService } from './file-upload.service';

declare var $:any;
declare var baseProgressBarStart:any;
declare var baseProgressBarEnd:any;

@Component({
  selector: 'ngx-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit, AfterViewInit {

  @Input() projectId: number;
  @Input() sectionId: number;
  @Input() fileExt: string = "JPG, JPEG, GIF, PNG, BMP";
  @Input() maxNumberOfFiles: number;
  @Input() maxUploadSize: number; // 5MB
  @Input() redirectUrl: string = '';
  @Input() uploadServiceApi: string = '';
  @Input() messageHeader: string = 'Upload Files';
  @Input() uploadData: any = null;
  @Input() folderId: string = null;
  @Input() packagetype: string = '';
  @Input() avaliablestorage: number = 0;
  @Input() hasUnlimitedStorage: boolean;

  @Output() fileDropped = new EventEmitter<any>();
  @Output() uploadStatus = new EventEmitter();
  @Output() onUploadStart = new EventEmitter();

  getPage: string;
  supportedFile: string;
  isShowDescription: boolean = false;
  dragAreaClass: string = 'dragarea';
  selectedFiles: any[] = [];
  errors: string[] = [];
  totalFilesSize: any;
  maxUploadSizeMessage: string = "";
  maxNumberOfFilesMessage: string = "";
  caseNumber: string;
  isExecuting: boolean = false;
  processSize: number = 0;
  totalAllBytesWritten: number;
  totalAllFileSize: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private toastService: ToastrService,
    private dialogService: NbDialogService,
    private fileUploadService: FileUploadService
  ) { 

  }

  ngOnInit(): void {
    this.getPage = this.router.url.split('/').pop();
  }

  ngAfterViewInit(): void {

    let maxNumberOfFilesCaption = "Number of files selected to upload exceeds the maximum file upload limit "+this.maxNumberOfFiles+" file(s)! Please reduce the number of files and try again.";
    let maxUploadSizeCaption = "Total size of files selected to upload exceeds the maximum file upload limit 2 GB! Please reduce the number of files and try again.";

    if(this.maxNumberOfFiles) {
      this.maxNumberOfFilesMessage = maxNumberOfFilesCaption;
    }

    if(this.maxUploadSize) {
      this.maxUploadSizeMessage = maxUploadSizeCaption;
    }
  }

  onFileChange(event): void {
    let files: any[] = Array.prototype.slice.call(event.srcElement.files);

    files.forEach(file => {
      file.modifiedDate = moment(new Date(file.lastModified)).format('MMM-DD-YYYY HH:mm:ss');
    });

    /** remove duplicate files **/
    files = files.filter(file => this.selectedFiles.indexOf(file) < 0);
    let filelength = files.length;
    /** validte supported file extensions */
    this.validateFileExtensions(files);

    files = files.filter(file => {
      let ext = file.name.toUpperCase().split('.').pop() || file.name;
      let extensions = (this.fileExt.split(','))
          .map(function (x) { return x.toLocaleUpperCase().trim() });
      let exists = extensions.includes(ext);
      return exists;
    });

    this.selectedFiles.push(...files);
    this.selectedFiles = _.uniqBy(this.selectedFiles, 'name');
    this.totalFilesSize = _.sumBy(this.selectedFiles, file => file.size);
    this.isShowDescription = true;

    if(files.length > 0 && files.length == filelength){
      this.toastService.success('Files are ready to upload. Please click Upload button to start uploading files.');
    }
  }

  @HostListener('dragover', ['$event']) onDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dragAreaClass = "droparea";
  }

  @HostListener('dragenter', ['$event']) onDragEnter(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dragAreaClass = "droparea";
  }

  @HostListener('dragend', ['$event']) onDragEnd(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dragAreaClass = "dragarea";
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dragAreaClass = "dragarea";
      
  }
  @HostListener('drop', ['$event']) onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dragAreaClass = "dragarea";
    this.isShowDescription = true;

    let files: any[] = Array.prototype.slice.call(event.dataTransfer.files);

    if (files.length === 0) {
      return;
    }

    files.forEach(file => {
        file.modifiedDate = moment(new Date(file.lastModified)).format('MMM-DD-YYYY HH:mm:ss');
    });

    let filelength = files.length;

    this.validateFileExtensions(files);

    // remove file that have invalid extension
    files = files.filter(file => {
        let ext = file.name.toUpperCase().split('.').pop() || file.name;
        let extensions = (this.fileExt.split(','))
            .map(function (x) { return x.toLocaleUpperCase().trim() });
        let exists = extensions.includes(ext);
        return exists;
    });

    this.selectedFiles.push(...files);

    // remove duplicate file name
    this.selectedFiles = _.uniqBy(this.selectedFiles, 'name');
    this.totalFilesSize = _.sumBy(this.selectedFiles, file => file.size);
    
    if(files.length > 0 && files.length == filelength){
       this.toastService.success('Files are ready to upload. Please click Upload button to start uploading files.');
    }
    
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  remove(file) {
    this.selectedFiles.splice(this.selectedFiles.indexOf(file), 1);
    this.populateFile();
    this.totalFilesSize = _.sumBy(this.selectedFiles, (file: any) => file.size);
  }

  removeAll() {
    this.selectedFiles = [];
  }

  cancel(): void {
    this.location.back();
  }

  upload() {
    this.saveFiles(this.selectedFiles);
  }

  saveFiles(files) {
    this.errors = [];
    let totalFilesSize = _.sumBy(files, (file: any) => file.size);

    if (totalFilesSize > this.maxUploadSize * 1024 * 1024) {
      this.dialogService.open(DialogOKComponent, {
        closeOnBackdropClick: false,
        context: {
          title: this.messageHeader,
          size: 'md',
          body: `Total size of files selected to upload exceeds the maximum file <br/>upload limit  <strong class="red-bold">2 GB</strong>! Please reduce the number of files and try again.`
        }
      });
      return;
    }

    if (files.length > this.maxNumberOfFiles) {
      this.dialogService.open(DialogOKComponent, {
        closeOnBackdropClick: false,
        context: {
          title: this.messageHeader,
          size: 'md',
          body: `Number of files selected to upload exceeds the maximum file <br/>upload limit <strong class="red-bold">${this.maxNumberOfFiles} file(s)</strong>! Please reduce the number of files and try again.`,
        }
      });
      return;
    }

    if (!this.hasUnlimitedStorage && (this.packagetype === 'storage' || this.packagetype === 'complete') && this.avaliablestorage < totalFilesSize) {

      let bodymsg = "Your file upload exceeds the available storage space in your QUICKTEL account. To continue, please remove some files or upgrade your storage plan.";
      bodymsg += `<br/><br/><b>Available Storage:</b> ${this.formatBytes(this.avaliablestorage, 2)}`;
      bodymsg += `<br/><b>Total Upload Size:</b> <span class="red-bold lh-30">${this.formatBytes(totalFilesSize, 2)}</span>`;

      this.dialogService.open(DialogOKComponent, {
        closeOnBackdropClick: false,
        context: {
          title: "Storage Limit Exceeded",
          size: 'md',
          body: bodymsg
        }
      });
      return;
    } 
    
    this.isExecuting = true;

    var formData = new FormData();

    for (let j = 0; j < files.length; j++) {

      formData.append("files", files[j]);
      formData.append("lastModified",files[j].lastModifiedDate);

    }

    this.fileUploadService.upload(formData,totalFilesSize,this.folderId).subscribe(response => {
      setTimeout(() => {
        this.uploadStatus.emit(response);
        this.isExecuting = false;
      }, 1000);
   
    }, error => {
      console.log(error);
      this.isExecuting = false;
      this.uploadStatus.emit({
        status: false,
        message: error
      });

    });
  }

  private validateFileExtensions(files: any[]) {
    let extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleUpperCase().trim() });
    let messages: string[] = [];
    for (let i = 0; i < files.length; i++) {
      // Get file extension
      let ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;
      // Check the extension exists
      let exists = extensions.includes(ext);
      if (!exists) {
          messages.push(`File not supported: [${files[i].name}]`);
      }
    }
    if (messages.length !== 0) {
      this.toastService.error(messages.join('<br />'));
    }
  }

  private populateFile() {

    let counter = {};

    // Count duplicate files by hash 
    this.selectedFiles.forEach(function (obj) {
      counter[obj.hash] = (counter[obj.hash] || 0) + 1
    });

    // Apply style to the list
    Object.keys(counter).forEach(key => {
      this.selectedFiles.filter(f => f.hash == key).forEach(f => {
        if (counter[key] && counter[key] > 1) {
          f.duplicated = true;
        } else {
          f.duplicated = false;
        }
      });
    });
  }

}
